<bb-page-header
	[icon]="'columns'"
	[title]="'POSITIONS' | translate"
	[filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath"
></bb-page-header>

<div class="body-column">
	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="vmap">{{ 'VMAP' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="preroll">{{ 'PREROLL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="postroll">{{ 'POSTROLL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="title">{{ row.data.name }}</bb-table-cell>
			<bb-table-cell property="vmap">{{ row.data.adunitsVMAP | commaSeparatedProperty : 'code' }}</bb-table-cell>
			<bb-table-cell property="preroll">{{ row.data.adunitsPreroll | commaSeparatedProperty : 'code' }}</bb-table-cell>
			<bb-table-cell property="postroll">{{ row.data.adunitsPostroll | commaSeparatedProperty : 'code' }}</bb-table-cell>
			<bb-table-cell property="status"><div [innerHtml]="row.data | statusIcon"></div></bb-table-cell>

			<bb-table-cell class="buttons" (click)="$event.stopPropagation()"><!-- stopPropagation so the row doesn't get selected -->
				<a class="button" (click)="goToUpgradedLink(row.data.id, $event)" [routerLink]="['/adservices/position/playout', row.data.id]">
					<i class="fa fa-edit"></i>
				</a>
			</bb-table-cell>

		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_ADPOSITIONS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
